import { render, staticRenderFns } from "./button-new.vue?vue&type=template&id=b65ce36a&scoped=true&"
import script from "./button-new.vue?vue&type=script&lang=js&"
export * from "./button-new.vue?vue&type=script&lang=js&"
import style0 from "./button-new.vue?vue&type=style&index=0&id=b65ce36a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65ce36a",
  null
  
)

export default component.exports